import { Box } from "@mui/material";
import { forwardRef, useEffect } from "react";
import HeaderContent from "./headerContent";
import PatientInformation from "./patientInformation";
import TestProfileSection from "./testProfileSection";
import BillingInformation from "./billingInformation";
import { useDispatch, useSelector } from "react-redux";
import { handleChangeMultiFields } from "store/slice/multiStepFormInputSlice";
import { handleChangeHandling } from "store/slice/specialHandlingSlice";
import notification from "components/mnl/global/openNotification";

export const FourthStep = forwardRef((props, ref) => {
  const { id, printTestOrder } = props;
  const multiStepFormInputs = useSelector((state) => state.multiStepFormInputs);
  const orderData = useSelector((state) => state.orderData);
  const savedHandlingItems = useSelector((state) => state.specialHandling);
  const dispatch = useDispatch();
  const concatenatedSaltIdAndEncryptedText = `${orderData?.encryptedTestOrderData?.saltId}:${orderData?.encryptedTestOrderData?.encryptedText}`;

  useEffect(() => {
    window.scrollTo(0, document.body.scrollHeight);
  }, []);

  const isAnyStatAllowed = multiStepFormInputs.testOrderDetails.some(
    (item) => item.hasOwnProperty("isStat") && item.isStat === true,
  );

  const isStatAdded = multiStepFormInputs.specialHandlings.includes(1);

  useEffect(() => {
    if (!isAnyStatAllowed && isStatAdded) {
      const filteredHandling = multiStepFormInputs.specialHandlings.filter(
        (handling) => handling !== 1,
      );

      const filteredSavedHandling = savedHandlingItems.savedHandling.filter(
        (handling) => handling.id !== 1,
      );
      dispatch(
        handleChangeMultiFields({
          specialHandlings: filteredHandling,
        }),
      );
      dispatch(
        handleChangeHandling({
          savedHandling: filteredSavedHandling,
        }),
      );
      const notificationToastTimeout = setTimeout(() => {
        notification.warning({
          message: "Removed STAT",
          description: (
            <div>
              Since <strong>STAT</strong> is not used in the laboratory tests
              you added, it has been removed.
            </div>
          ),
        });
      }, 1000);

      return () => clearTimeout(notificationToastTimeout);
    }
    // eslint-disable-next-line
  }, [isAnyStatAllowed]);

  return (
    <div id={id}>
      <Box
        ref={ref}
        sx={{
          flexGrow: 1,
          padding: {
            xs: "0.3rem",
            sm: "0.3rem",
            md: "0.9rem",
            lg: "2rem",
            xl: "2rem",
          },
        }}
      >
        <HeaderContent printTestOrder={printTestOrder} />
        <PatientInformation printTestOrder={printTestOrder} />
        <TestProfileSection printTestOrder={printTestOrder} />
        <BillingInformation printTestOrder={printTestOrder} />
        {orderData.successfullyCreatedOrder && (
          <p
            className="whitespace-normal text-center mt-8"
            style={{
              wordBreak: "break-all",
              whiteSpace: "pre-wrap",
              overflowWrap: "break-word",
            }}
          >
            {concatenatedSaltIdAndEncryptedText}
          </p>
        )}
      </Box>
    </div>
  );
});
